export const fiData = `
  <div class="paragraph">
    <div class="page-title">Usein kysytyt kysymykset Trade-In-ohjelmasta (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Kuka voi osallistua Trade-In-ohjelmaan?</div>
    <div class="text-box">
      <div class="text">
        Trade-In-palvelu on saatavilla vähintään 18-vuotiaille henkilöille, jotka asuvat laillisesti Euroopan unionin jäsenvaltiossa tai Yhdistyneessä kuningaskunnassa.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Mitä minun tulee tehdä ennen kuin lähetän vanhan laitteeni?</div>
    <div class="text-box">
      <div class="text">
        Ennen laitteen lähettämistä:<br>
        • Poista kaikki henkilökohtaiset tiedot sekä PIN-koodit, salasanat ja näytön lukitukset.<br>
        • Suorita täydellinen tehdasasetusten palautus.<br>
        • iPhonessa: poista iCloud-tili käytöstä ottamalla pois "Etsi iPhoneni" -toiminto.<br>
        • Androidissa: poista Google-tilisi (Asetukset > Tilit > Google > Poista tili).<br>
        Tämä varmistaa, ettei laite ole enää yhteydessä tiliisi ja suojaa henkilötietojasi.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kuinka voin lähettää vanhan laitteeni?</div>
    <div class="text-box">
      <div class="text">
        <strong>Pakkaus:</strong> käytä tukevaa ja läpinäkymätöntä laatikkoa (ei läpinäkyvää) ja lisää sisäinen suojaus (esim. kuplamuovi) vaurioiden estämiseksi kuljetuksen aikana.<br>
        <strong>Lähetysetiketti:</strong> jos sinulla ei ole sopivaa pakkausmateriaalia, voit pyytää sitä noutopisteestä, kun jätät pakettisi.<br>
        <strong>Dokumentit:</strong> tulosta, täytä ja allekirjoita Rehellisyysilmoitus, ja laita se pakkaukseen ennen sen sulkemista.<br>
        <strong>Turvallinen sulkeminen:</strong> varmista, että pakkaus on kunnolla suljettu, ja kiinnitä ilmainen lähetysetiketti näkyvälle paikalle.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Minkä tyyppisiä laitteita ei hyväksytä?</div>
    <div class="text-box">
      <div class="text">
        Emme hyväksy laitteita, jotka:<br>
        • ovat SIM-lukittuja operaattorille;<br>
        • eivät käynnisty tai lataudu;<br>
        • eivät voi muodostaa yhteyttä Bluetoothin tai Wi-Fin kautta;<br>
        • sisältävät sisäisen komponentti- tai emolevyvian;<br>
        • ovat edelleen liitetty iCloud- tai Google-tileihin;<br>
        • ovat väärennöksiä tai jäljitelmiä;<br>
        • ovat vakavasti vaurioituneita.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Pitääkö minun lähettää myös lisävarusteet (laturi, kaapeli jne.)?</div>
    <div class="text-box">
      <div class="text">
        Se ei ole pakollista, mutta suositeltavaa. Lisävarusteiden mukaan liittäminen tukee kestävyyttä ja laitteiden asianmukaista uudelleenkäyttöä.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Pitääkö minun lähettää kuulokkeet?</div>
    <div class="text-box">
      <div class="text">
        Ei. Hygieniasyistä kuulokkeet hävitetään, eikä niitä huomioida arvioinnissa.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Pitääkö minun lähettää ostokuitti?</div>
    <div class="text-box">
      <div class="text">
        Ei, sitä ei tarvita arviointia tai maksua varten. Voit säilyttää sen omia asiakirjojasi varten.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Miten vanha laitteeni arvioidaan?</div>
    <div class="text-box">
      <div class="text">
        Käytämme sertifioitua diagnostiikkaohjelmistoa ja suoritamme manuaalisen tarkastuksen arviointikeskuksessamme laitteen kunnon määrittämiseksi. Kaikki arviointi- ja tietojenkäsittelytoimenpiteet noudattavat EU:n yleistä tietosuoja-asetusta (GDPR – EU 2016/679), mikä takaa tietojesi turvallisuuden ja luottamuksellisuuden.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Mitä tapahtuu, jos ilmoittamani kunto ei vastaa arviointianne?</div>
    <div class="text-box">
      <div class="text">
        Jos ilmoittamasi ja arvioitu kunto eroavat toisistaan, lähetämme sinulle sähköpostitse:<br>
        • <strong>Päivitetyn tarjouksen</strong> todellisen tarkastuksen perusteella.<br>
        • <strong>Diagnostiikkaraportin</strong> ja perustelut eroavaisuuksille.<br><br>
        Voit hyväksyä tai hylätä tarjouksen:<br>
        • Jos hyväksyt, vaihto-prosessi saatetaan päätökseen, ja saat maksun pankkitilillesi 3 työpäivän kuluessa.<br>
        • Jos hylkäät, palautusprosessi riippuu sijainnistasi:<br>
        &nbsp;&nbsp;• Asiakkaille Espanjassa: palautuslähetys järjestetään maksutta, ja sen kustannuksista vastaa Danghuan Europe S.L.<br>
        &nbsp;&nbsp;• Asiakkaille Espanjan ulkopuolella: palautusmaksu voi olla enintään 22 EUR / 19 GBP / 165 DKK / 245 SEK (sis. ALV).<br>
        &nbsp;&nbsp;• Maksu on suoritettava 5 kalenteripäivän kuluessa maksupyynnön vastaanottamisesta käyttämällä Danghuanin toimittamaa virallista ennakkomaksettua palautuslähetystarraa.<br>
        &nbsp;&nbsp;• Maksutiedot toimitetaan pyynnöstä tai sisällytetään sähköpostiin, joka sisältää maksulinkin.<br>
        &nbsp;&nbsp;• Kun maksu (tarvittaessa) on vahvistettu, Danghuan tarkistaa tapahtuman 5 työpäivän kuluessa ja järjestää palautuslähetyksen alkuperäiseen osoitteeseesi. Saat sähköpostiviestin, kun lähetys on tehty, sisältäen seurantatiedot.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Mitä tapahtuu, jos en vastaa päivitettyyn tarjoukseen?</div>
    <div class="text-box">
      <div class="text">
        Jos vastausta ei vastaanoteta 30 kalenteripäivän kuluessa ilmoituspäivästä, päivitetty tarjous katsotaan automaattisesti hylätyksi.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Mitä tapahtuu henkilötiedoilleni?</div>
    <div class="text-box">
      <div class="text">
        Sinun on poistettava kaikki tiedot ennen laitteen lähettämistä. Jos havaitsemme jäljellä olevia tietoja, keskeytämme prosessin ja otamme sinuun yhteyttä niiden poistamiseksi. Noudatamme täysin GDPR-asetusta (EU 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kuka maksaa toimituskulut?</div>
    <div class="text-box">
      <div class="text">
        Ensimmäinen lähetys on aina maksuton.<br><br>
        Jos hylkäät päivitetyn tarjouksen:<br>
        • Asiakkaille Espanjassa: palautuslähetys järjestetään maksutta ja sen kustannuksista vastaa Danghuan Europe S.L.<br>
        • Asiakkaille Espanjan ulkopuolella: palautusmaksu voi olla enintään 22 EUR / 19 GBP / 165 DKK / 245 SEK (sis. ALV).<br>
        • Maksu on suoritettava 5 kalenteripäivän kuluessa maksupyynnön vastaanottamisesta käyttämällä virallista ennakkomaksettua palautustarraa, jonka toimittaa Danghuan.<br>
        • Maksutiedot toimitetaan pyynnöstä tai sisällytetään sähköpostiin, joka sisältää maksulinkin.<br>
        • Kun maksu (tarvittaessa) on vahvistettu, Danghuan tarkistaa tapahtuman 5 työpäivän kuluessa ja järjestää palautuksen alkuperäiseen osoitteeseesi. Saat sähköpostin, kun paketti on lähetetty, sekä vastaavat seurantatiedot.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Mitä tapahtuu, jos pakettini katoaa kuljetuksen aikana?</div>
    <div class="text-box">
      <div class="text">
        Jos laitteesi katoaa kuljetuksen aikana, Danghuan Europe S.L. auttaa sinua virallisessa reklamaatioprosessissa kuljetusyhtiön kanssa.<br><br>
        Lähetys katsotaan kadonneeksi, jos sitä ei ole seurattu, vahvistettu tai vastaanotettu 15 kalenteripäivän kuluessa luovutuksesta kuljettajalle.<br><br>
        • Sinun on käytettävä Danghuanin toimittamaa virallista ennakkomaksettua lähetysetikettiä; minkä tahansa muun menetelmän käyttö mitätöi katoamissuojan.<br>
        • UPS-reklamaatiot on tehtävä 60 päivän kuluessa etiketin luomisesta.<br>
        • CORREOS (Espanja) -lähetyksissä reklamaatiot tulisi tehdä mahdollisimman pian, mieluiten 15 päivän kuluessa ja viimeistään 1 vuoden kuluessa lähetyspäivästä.<br>
        • Danghuan avustaa kuljetusyhtiön tutkimuksessa, joka kestää yleensä 30–60 päivää.<br><br>
        Jos katoaminen vahvistetaan Danghuanin logistiikkajärjestelmässä ja virallinen etiketti on käytetty, korvaus ei ylitä laitteen lopullista arvioitua vaihtohyvitysarvoa.<br><br>
        Hyväksytyt maksut siirretään suoraan rekisteröinnin yhteydessä ilmoitettuun IBAN-tiliin.<br><br>
        <em>Huom: Kaikki korvaukset riippuvat kuljetusyhtiön politiikasta.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Milloin saan maksun?</div>
    <div class="text-box">
      <div class="text">
        Kun lopullinen tarjous on hyväksytty, maksu suoritetaan pankkisiirtona 3 työpäivän kuluessa. Varmista, että IBAN ja henkilökohtainen tunnistenumerosi ovat oikein ja vastaavat tilinomistajan tietoja.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Onko henkilökohtaisen tunnistenumeron antaminen pakollista?</div>
    <div class="text-box">
      <div class="text">
        Kyllä. Maksun käsittelyä varten sinun on annettava voimassa oleva henkilökohtainen tunnistenumero, ilman välilyöntejä tai erikoismerkkejä, ja sen on vastattava IBAN-tilin omistajaa.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Voinko peruuttaa Trade-In-prosessini?</div>
    <div class="text-box">
      <div class="text">
        Kyllä, jos vanhasta laitteestasi ei ole vielä maksettu. Ota yhteyttä mahdollisimman pian osoitteeseen <a href="mailto:insta360@danghuan.eu">insta360@danghuan.eu</a>. Jos olet jo lähettänyt laitteesi, ota meihin yhteyttä 48 tunnin kuluessa; muussa tapauksessa kierrätysprosessi jatkuu normaalisti.
      </div>
    </div>
  </div>
`;